module.exports = __webpack_public_path__ + "img/doctor.ad2d2225.svg";